import { DefaultState } from 'store/types';

export const PREFERRED_ROOMMATES_DATA_REQUEST = 'PREFERRED_ROOMMATES_DATA_REQUEST';
export const PREFERRED_ROOMMATES_DATA_SUCCESS = 'PREFERRED_ROOMMATES_DATA_SUCCESS';
export const PREFERRED_ROOMMATES_DATA_FAILURE = 'PREFERRED_ROOMMATES_DATA_FAILURE';

export interface PreferredRoommate {
  id: string;
  name: string;
  gender: string;
  relationType: string;
  fromDate: Date;
  toDate: Date;
  status: string;
};

export type PreferredRoommatesData = PreferredRoommate[];

export type PreferredRoommatesState = DefaultState & {
  contents?: PreferredRoommatesData;
};

interface ReadPreferredRoommatesDataRequest {
  type: typeof PREFERRED_ROOMMATES_DATA_REQUEST;
};

interface ReadPreferredRoommatesDataSuccess {
  type: typeof PREFERRED_ROOMMATES_DATA_SUCCESS,
  contents: PreferredRoommatesData;
}

interface ReadPreferredRoommatesDataFailure {
  type: typeof PREFERRED_ROOMMATES_DATA_FAILURE;
}

export type PreferredRoommatesActionTypes = ReadPreferredRoommatesDataRequest | ReadPreferredRoommatesDataSuccess | ReadPreferredRoommatesDataFailure;